'use client'

import style from '@trustoo/components/ui/linearLoader.module.css'
import clsx from 'clsx'
import { ComponentPropsWithoutRef, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

interface LinearLoaderProps extends ComponentPropsWithoutRef<'div'> {
    fixed?: boolean
    absolute?: boolean
    portalId?: string
}

const LinearLoader = ({
    fixed,
    absolute,
    portalId = 'portal_1',
    className,
    ...rest
}: LinearLoaderProps) => {
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        setMounted(true)
    }, [])

    const loader = (
        <div
            className={clsx(
                style.linearProgress,
                fixed && style.fixed,
                absolute && style.absolute,
                className,
            )}
            {...rest}>
            <div className={clsx(style.bar, style.bar1)} />
            <div className={clsx(style.bar, style.bar2)} />
        </div>
    )

    if (mounted && fixed) {
        const portalElement = document.getElementById(portalId)
        return portalElement ? createPortal(loader, portalElement) : loader
    }

    // Keep the loader visible in the server HTML and initial hydration tree. Once mounted, fixed
    // loaders move into the portal above so transformed or clipped ancestors cannot contain them.
    return loader
}

export default LinearLoader
